
















































































import {
    defineComponent,
    watch,
    ref,
} from '@vue/composition-api';

export default defineComponent({
    props: {
        isUnlocked: {
            type: Boolean,
            required: true,
        },
        selections: {
            type: Number,
            required: true,
        },
        selectionsForFirstBonus: {
            type: Number,
            required: true,
        },
        selectionsNeededForNext: {
            type: Number,
            required: true,
        },
        nextPercentage: {
            type: Number,
            required: true,
        },
        percentage: {
            type: Number,
            required: true,
        },
        maximumPercentage: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const animationDuration = 750;
        const shouldShowProgressBar = ref(false);
        const progressBarStyle = ref({});

        const runAnimation = () => {
            shouldShowProgressBar.value = true;
            setTimeout(() => {
                shouldShowProgressBar.value = false;
            }, animationDuration);
        };

        watch(
            () => props.percentage,
            (newPercentage, oldPercentage) => {
                if (props.isUnlocked && newPercentage !== oldPercentage) {
                    runAnimation();
                }
            },
            { immediate: true },
        );

        return {
            shouldShowProgressBar,
            progressBarStyle,
        };
    },
});
